import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '@services/auth.service';
import { LOCAL_STORAGE_KEY, StorageService } from '@services/storage.service';
import { ROUTE_PATH } from '@shared/enum/common.enum';

export const loginGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const storageService = inject(StorageService);
    const router = inject(Router);

    const currentUser = JSON.parse(
        storageService.getItem(LOCAL_STORAGE_KEY.USER_ID)!
    );
    const isPasswordChanged = JSON.parse(
        storageService.getItem(LOCAL_STORAGE_KEY.IS_PASSWORD)!
    );
    if (
        authService.isAuthenticated() &&
        !currentUser.is_password_changed &&
        !isPasswordChanged
    ) {
        router.navigate([ROUTE_PATH.RESET_PASSWORD]);
        return false;
    } else if (
        authService.isAuthenticated() &&
        currentUser.is_password_changed &&
        isPasswordChanged
    ) {
        router.navigate([ROUTE_PATH.DASHBOARD]);
        return false;
    } else if (storageService.getItem(LOCAL_STORAGE_KEY.TEMP_TOKEN) !== null) {
        router.navigate([ROUTE_PATH.OTP]);
        return false;
    } else {
        return true;
    }
};
